import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2
} from '@angular/core';
import {Router} from '@angular/router';

import {LIST_TYPE} from '../../defines/client.const';
import {clickOutsideLinkMixin} from '../../mixin/click-outside.mixin';
import {ExampleSJ} from '../../models/example-sj.model';
import {WordDetailExample} from '../../models/word.model';
import {GlobalEventService} from '../../services/global-event/global-event.service';

@Component({
  selector: 'app-link-example-popup',
  templateUrl: './link-example-popup.component.html',
  styleUrls: ['./link-example-popup.component.scss'],
})
export class LinkExamplePopupComponent extends clickOutsideLinkMixin implements OnInit, AfterViewInit, OnDestroy {
  @HostBinding('style.position') stylePosition = 'absolute';
  @HostBinding('style.top') styleTop = '0';
  @HostBinding('style.left') styleLeft = '0';
  @HostBinding('style.z-index') styleZIndex = '1001';

  @Input() example: WordDetailExample | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() viewInit = new EventEmitter<HTMLElement>();

  constructor(
    public override elementRef: ElementRef,
    public override renderer: Renderer2,
    public override globalEventSvc: GlobalEventService,
    private router: Router,
  ) {
    super(elementRef, renderer, globalEventSvc);
  }

  ngOnInit(): void {
    const offsetParent = this.elementRef.nativeElement.offsetParent as HTMLElement | null;
    if (!offsetParent) {
      throw new Error('LinkExamplePopupComponent.ngOnInit: offsetParent is null');
    }

    this.styleTop = `${offsetParent.offsetHeight + 8}px`;
    this.coInit(() => this.close.emit());
  }

  ngAfterViewInit(): void {
    this.viewInit.emit(this.elementRef.nativeElement.firstChild);
  }

  ngOnDestroy(): void {
    this.coDestroy();
  }

  onVoid(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);
  }

  onClose(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event);
    this.close.emit();
  }

  onClickDetail(event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.globalEventSvc.Click(event, true);

    if (!this.example) {
      throw new Error('LinkExamplePopupComponent.onClickDetail: example is null');
    }

    this.close.emit();
    this.router.navigate(['/example', LIST_TYPE.SERVER], {
      queryParams: {
        id: this.example.id,
      },
    }).then();
  }

  protected get exampleSJ(): ExampleSJ | null {
    if (!this.example?.example_t || !this.example?.example_s) {
      return null;
    }

    return {
      seungjo: this.example.example_s,
      example: this.example.example_t,
      voiceExIdx: null,
      highlight: this.example.example_highlight,
    };
  }
}
